import { render, staticRenderFns } from "./ResortIndex.vue?vue&type=template&id=b77aa5e4&"
import script from "./ResortIndex.vue?vue&type=script&lang=js&"
export * from "./ResortIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports